export default __webpack_public_path__ + "static/media/admin.ff49f7f5.svg";